import { Skeleton } from '../../../Skeleton'
import { BIRDVIEW_CARD_SKELETON_ROWS_COUNT } from '../BirdviewCard.constants'

import * as styles from './BirdviewCardSkeleton.module.css'

function BirdviewCardSkeleton() {
  return Array.from({ length: BIRDVIEW_CARD_SKELETON_ROWS_COUNT }, (_, row) => (
    <div className={styles.skeletonRow} key={row}>
      <Skeleton className={styles.skeletonBar} />
    </div>
  ))
}

export default BirdviewCardSkeleton
